import { executeGet } from '../common/apiCaller'
import { GetInterviewReservationsDaysDto, GetInterviewReservationsDaysInputDto } from '../dto/interviewReservationsDaysDto'

const apiName = 'citizen'
const apiPath = '/facilities'

export const executeGetInterviewReservationsDays = (id: string, input?: GetInterviewReservationsDaysInputDto) => {
  return executeGet<GetInterviewReservationsDaysDto[]>(apiName, `${apiPath}/${id}/interviews/days`, input)
}
